import { render, staticRenderFns } from "./Numbers.vue?vue&type=template&id=7c5e1491&scoped=true"
import script from "./Numbers.vue?vue&type=script&lang=js"
export * from "./Numbers.vue?vue&type=script&lang=js"
import style0 from "./Numbers.vue?vue&type=style&index=0&id=7c5e1491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5e1491",
  null
  
)

export default component.exports